import { Box, styled } from "@mui/material";
import { forwardRef, useEffect, useRef } from "react";
import videojs, { VideoJsPlayer, VideoJsPlayerOptions } from "video.js";
import "video.js/dist/video-js.css";
// import "@videojs/themes/dist/fantasy/index.css";


// interface IVideoPlayerProps {
//   options: VideoJsPlayerOptions
//   onReady?: (player: VideoJsPlayer) => void;
// }
const StyledVideoContainer = styled(Box)`
  video-js {
    &.vjs-theme-fantasy {
      --vjs-theme-fantasy--primary: red !important;
    }
    .vjs-slider-horizontal {
      .vjs-volume-level {
        &:before {
          line-height: 1;
        }
      }
    }
  }
`;
const initialOptions = {
  controls: true,
  controlBar: {
    volumePanel: {
      inline: true,
    },
    pictureInPictureToggle: true,
  },
};
export const VideoJS = forwardRef(
  (props, mainContainerRef) => {
    const videoRef = useRef(null);
    const playerRef = useRef(null);
    const { options, onReady } = props;

    useEffect(() => {
      // Make sure Video.js player is only initialized once
      if (!playerRef.current) {
        // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
        const videoElement = document.createElement("video-js");

        videoElement.classList.add("vjs-big-play-centered");
        videoElement.classList.add("vjs-theme-fantasy");
        if (videoRef.current) {
          videoRef.current.appendChild(videoElement);
        }

        const player = (playerRef.current = videojs(
          videoElement,
          { ...initialOptions, ...options },
          () => {
            onReady && onReady(player);
          }
        ));

        // You could update an existing player in the `else` block here
        // on prop change, for example:
      } else {
        const player = playerRef.current;
        if (options.autoplay) {
          player.autoplay(options.autoplay);
        }
        if (options.sources) {
          player.src(options.sources);
        }
      }
    }, [JSON.stringify(options), videoRef]);

    // Dispose the Video.js player when the functional component unmounts
    useEffect(() => {
      const player = playerRef.current;
      return () => {
        if (player && !player.isDisposed()) {
          player.dispose();
          playerRef.current = null;
        }
      };
    }, [playerRef]);

    return (
      <StyledVideoContainer
        component={"div"}
        data-vjs-player
        ref={mainContainerRef}
      >
        <StyledVideoContainer component={"div"} ref={videoRef} />
      </StyledVideoContainer>
    );
  }
);
VideoJS.displayName = "VideoJS";
export default VideoJS;
